var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"display":"block"},attrs:{"id":"vipOpenButton"}},[_c('div',{staticClass:"vip-center"},[_c('button',{on:{"click":_vm.toPay}},[_vm._v("立即免费下载")]),_vm._v(" "),_c('div',{staticClass:"vip-img"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4770ab5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/channel/channelFoot.vue
// module id = null
// module chunks = 